import React, { useContext, useState } from "react";

import { Button, ButtonSizeEnum } from "@/components/common/button";
import { Icon, IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import UserContext from "@/contexts/User/UserContext";
import useOnboardingForClient from "@/hooks/useOnboardingForClient";
import MarketingUtils from "@/marketing/marketingUtils";

import { FormTypeEnum } from "../../modals/types";
import { setAuthParamToURL } from "../../modals/utils";

import { randomOnboardingStarDelays } from "./utils";

const OnboardingBanner = () => {
  const { isActiveOnboarding } = useOnboardingForClient();
  const { userID } = useContext(UserContext);
  const [starDelays] = useState<[number, number, number, number]>(randomOnboardingStarDelays);

  if (!isActiveOnboarding) {
    return null;
  }

  return (
    <div className="onboarding-top-banner-slot">
      <div
        className="header__onboarding-banner"
        onClick={() => {
          setAuthParamToURL(window?.location, FormTypeEnum.Onboarding);
          MarketingUtils.marketingOnboardingAnswers(userID, "step-0", "The onboarding modal was opened");
        }}
      >
        <div className="header__onboarding-banner-inner">

          <div className="header__onboarding-banner-content header__onboarding-banner-content--center">
            <div className="header__onboarding-banner-stars header__onboarding-banner-stars--left" aria-hidden>
              <span
                className="header__onboarding-banner-star-slot header__onboarding-banner-star-slot--left-top"
              >
                <span
                  className="header__onboarding-banner-star-wrap header__onboarding-banner-star-wrap--twinkle"
                  style={{ animationDelay: `${starDelays[0]}s` }}
                >
                  <Icon
                    type={IconTypeEnum.Stars}
                    className="header__onboarding-banner-star"
                    viewBox={14}
                    size={IconSizeEnum.Size14}
                  />
                </span>
              </span>
              <span
                className="header__onboarding-banner-star-slot header__onboarding-banner-star-slot--left-bottom"
              >
                <span
                  className="header__onboarding-banner-star-wrap header__onboarding-banner-star-wrap--twinkle"
                  style={{ animationDelay: `${starDelays[1]}s` }}
                >
                  <Icon
                    type={IconTypeEnum.Stars}
                    className="header__onboarding-banner-star"
                    viewBox={8}
                    size={IconSizeEnum.Size8}
                  />
                </span>
              </span>
            </div>
            <p className="header__text-free-call">
              1-я консультация
              {" "}
              <span>бесплатно</span>
            </p>
            <Button text="Подобрать таролога" size={ButtonSizeEnum.Small} className="header__onboarding-banner-button" />
            <div className="header__onboarding-banner-stars header__onboarding-banner-stars--right">
              <span
                className="header__onboarding-banner-star-slot header__onboarding-banner-star-slot--right-top"
              >
                <span
                  className="header__onboarding-banner-star-wrap header__onboarding-banner-star-wrap--twinkle"
                  style={{ animationDelay: `${starDelays[2]}s` }}
                >
                  <Icon
                    type={IconTypeEnum.Stars}
                    className="header__onboarding-banner-star"
                    viewBox={14}
                    size={IconSizeEnum.Size14}
                  />
                </span>
              </span>
              <span
                className="header__onboarding-banner-star-slot header__onboarding-banner-star-slot--right-bottom"
              >
                <span
                  className="header__onboarding-banner-star-wrap header__onboarding-banner-star-wrap--twinkle"
                  style={{ animationDelay: `${starDelays[3]}s` }}
                >
                  <Icon
                    type={IconTypeEnum.Stars}
                    className="header__onboarding-banner-star"
                    viewBox={8}
                    size={IconSizeEnum.Size8}
                  />
                </span>
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
export default OnboardingBanner;
